export const CompanyThemes = {
  Id: 'Identifikátor',
  Active: 'Aktivní',
  Company: 'Společnost',
  Metadata: 'Metadata',
  Theme: 'Téma',
  Version: 'Verze',
};
